<template>
  <div
    class="reviewBlock mb-8"
    :class="props.data.classes"
  >
    <div class="reviewBlock__review">
      <div class="quoteIcon">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="104"
          height="105"
          viewBox="0 0 104 105"
          fill="none"
        >
          <g clip-path="url(#clip0_1311_919)">
            <path
              d="M44.0066 20.4686V33.5092C39.884 33.7367 36.7624 34.4891 34.645 35.7679C32.526 37.0468 31.0375 39.1203 30.1779 41.9901C29.3199 44.8598 28.8893 48.9646 28.8893 54.3059H44.0066V85.4166H13V55.8399C13 43.6232 15.6195 34.6743 20.8585 28.9917C26.0991 23.3091 33.8146 20.4686 44.0066 20.4686ZM90.8164 20.4686V33.5092C86.6938 33.7367 83.5737 34.4614 81.4547 35.6834C79.3357 36.9038 77.8034 38.9789 76.8593 41.9056C75.9151 44.8306 75.4423 48.9646 75.4423 54.3059H90.8164V85.4166H59.6391V55.8399C59.6391 43.6232 62.244 34.6743 67.4538 28.9917C72.6651 23.3091 80.4521 20.4686 90.8164 20.4686Z"
              fill="#BFBFBD"
            />
          </g>
          <defs>
            <clipPath id="clip0_1311_919">
              <rect
                width="104"
                height="104"
                fill="white"
                transform="translate(0 0.559998)"
              />
            </clipPath>
          </defs>
        </svg>
      </div>

      <blockquote>
        <p>{{ props.data.content }}</p>
      </blockquote>

      <cite class="reviewBlock__review__client">
        <strong class="text-block extra-small">
          <span class="name">{{ props.data.title }}</span>
          <span class="position"> | {{ props.data.descr }}</span>
        </strong>
      </cite>
    </div>
    <div class="reviewBlock__logo">
      <img
        v-if="props.data.icon && props.data.icon.indexOf('http') !== -1"
        :src="props.data.icon"
      />

      <span
        v-else
        :class="props.data.icon"
      ></span>
    </div>
  </div>
</template>

<script setup>
/**
* Props
*/
const props = defineProps({
  data: {
    type: [Object],
    default: null
  }
})
</script>

<style lang="scss" scope>
.reviewBlock {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  @media only screen and (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: flex-end;
  }
  &__review {
    display: flex;
    flex-wrap: wrap;
    .quoteIcon {
      position: absolute;
      svg {
        @media only screen and (max-width: 992px) {
          width: 50px;
          height: 50px;
        }
      }
    }
    blockquote {
      flex: 1 1 100%;
      padding-top: 1rem;
      padding-left: 110px;
      margin: 0;
      color: #666;
      font-size: 1rem;
      font-style: italic;
      font-weight: 300;
      line-height: 150%;
      letter-spacing: .48px;
      border-left: none;
      p {
        margin: 0;
      }
      @media only screen and (max-width: 992px) {
        padding-top: 1rem;
        padding-left: 60px;
        font-size: 14px;
        font-weight: 300;
      }
      @media only screen and (max-width: 768px) {
        font-size: 11px;
      }
    }
    &__client {
      flex: 1 1 100%;
      padding-left: 110px;
      font-style: italic;
      @media only screen and (max-width: 992px) {
        padding-left: 60px;
      }
      .name {
        font-size: 1rem;
        font-weight: 400;
        line-height: 1rem;
        letter-spacing: .2px;
        @media only screen and (max-width: 992px) {
          font-size: 14px;
          font-weight: 300;
        }
        @media only screen and (max-width: 768px) {
          font-size: 11px;
        }
      }
      .position {
        font-size: .8rem;
        font-weight: 300;
        line-height: 150%;
        letter-spacing: .14px;
        @media only screen and (max-width: 992px) {
          font-size: 12px;
          font-weight: 300;
        }
        @media only screen and (max-width: 768px) {
          font-size: 11px;
        }
      }
    }
  }
  &__logo {
    display: block;
    flex: 0 0 110px;
    height: 30px;
    padding-left: 1rem;
    margin-top: 1rem;
    opacity: .5;
    @media only screen and (max-width: 992px) {
      margin-top: 0;
    }
    @media only screen and (max-width: 768px) {
      flex: 0 0 80px;
      height: 20px;
    }

    .icon {
      font-size: 4rem;
      line-height: 4rem;
      @media only screen and (max-width: 768px) {
        font-size: 2rem;
        line-height: 2rem;
      }
    }
  }
}
</style>
